import src from "IMAGE";
export default { src, width: 1920, height: 1080, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAR0lEQVR42nWNsQkAQQgE5e/g1BaMLcBMVOy/rJcPH26CZTdYBuDG87HW+hVQ1e5296oys8yMCBGBvTcRnXMQcZKZZ87vqngBWHsFqp8d4J4AAAAASUVORK5CYII="};
